import dynamic from "dynamic";
import appConfig from "app-core/config";

export function getArrVal(arr, idx, field) {
    const value = arr[idx] && arr[idx][field || 'name'] || '';
    if (typeof (value) === 'function')
        return value();
    return value;
}

export function activateSubscription(subscriptionId) {
    const that = appConfig.getVueApp();
    if (__DEBUG__)
        console.debug('Activate subscription', subscriptionId);
    return new Promise((resolve, reject) => {
        const successUrl = encodeURIComponent(`${window.location.href.split('#')[0]}#/pay?success=true&redirectTo=company/profile`);
        that.$Data.getExternalApi('CustomerSubscription/CreateSubscriptionSession', `subscriptionId=${subscriptionId}&backUrl=${encodeURIComponent(window.location.href)}&successUrl=${successUrl}`)
            .then(session => {
                if (session.Success) {
                    const sessionId = session.Data;
                    that.$Data.getStripeKey().then(key => {
                        dynamic.loadOnce(['https://js.stripe.com/v3/'], 'js').then(() => {
                            const stripe = Stripe(key);
                            stripe.redirectToCheckout({
                                sessionId: sessionId
                            }).then(handleResult).catch(error => {
                                that.$notifyError(error, 5000)
                                reject();
                            });
                        });
                    });
                    resolve();
                } else {
                    that.$notifyError(session.ErrorMessage, 5000);
                    reject();
                }
            });
    })
}